/** Draft and identity helpers shared by the PO editors. */
export function cloneDraft<T>(value: T): T { return structuredClone(value); }
export function inventoryKey(row: any): any { return row?.InventoryID ?? row?._tempKey; }
export function sameInventory(a: any, b: any): boolean {
  const key = inventoryKey(a);
  return key != null && String(key) === String(inventoryKey(b));
}
export function upsertInventory(rows: any[], edited: any): any[] {
  const parent = cloneDraft(edited);
  const child = parent.DecafInventory;
  const deletedId = parent.__deleteChildId;
  delete parent.DecafInventory;
  delete parent.Child;
  delete parent.__deleteChildId;
  const index = rows.findIndex(row => sameInventory(row, parent));
  const old = index >= 0 ? rows[index] : null;
  parent._tempKey ??= parent.InventoryID ?? crypto.randomUUID();
  const linked = rows.filter(row => parent.InventoryID != null && String(row.ParentInventoryID) === String(parent.InventoryID));
  const existingChildren = [...(old?.ChildInventory ?? []), ...linked];
  parent.ChildInventory = child ? [{ ...cloneDraft(child), ParentInventoryID: parent.InventoryID ?? null,
    _parentTempKey: parent._tempKey, IsChild: true, readOnly: true }] : existingChildren;
  if (deletedId != null) parent.ChildInventory = parent.ChildInventory.filter((row: any) => String(row.InventoryID) !== String(deletedId));
  const result = rows.filter(row => !linked.includes(row) && !sameInventory(row, parent));
  result.splice(index < 0 ? result.length : Math.min(index, result.length), 0, parent);
  return result;
}
export function matchesPurchaseOrder(po: any, option: string, query: string): boolean {
  const search = query.trim().toLowerCase();
  if (!search) return true;
  const contains = (value: any) => String(value ?? '').toLowerCase().includes(search);
  return (po.GroupedPurchaseOrders ?? [po]).some((member: any) => {
    if (option === 'PO #') return contains(member.PurchaseOrderID);
    return (member.Inventory ?? []).some((row: any) => contains(option === 'Reference #' ? row.InventoryID : row.SupplierReffNumber));
  });
}

export function childInventoryType(row: any, parent?: any): string {
  const source = parent ?? {InventoryTypeID:row.ParentInventoryTypeID,FinalDestinationWarehouseID:row.ParentDestinationWarehouseID,DecaffeinatorID:row.ParentDecaffeinatorID};
  const labels: string[] = [];
  const decaf = Number(row.DecaffeinatorID) > 0 && Number(row.DecaffeinatorID) !== Number(source.DecaffeinatorID ?? 0);
  if (decaf) labels.push('Decaf');
  if (row.SlackBag === true || Number(row.SlackBag) === 1) labels.push('Slack');
  if (row.TransferStatus || row.TransferContainerID || (source.FinalDestinationWarehouseID != null && row.FinalDestinationWarehouseID != null && Number(source.FinalDestinationWarehouseID) !== Number(row.FinalDestinationWarehouseID))) labels.push('Transfer');
  if (!decaf && source.InventoryTypeID != null && row.InventoryTypeID != null && Number(source.InventoryTypeID) !== Number(row.InventoryTypeID)) labels.push('SKU change');
  if (!labels.length && Number(row.NetWeight) === 22 && Number(source.NetWeight) !== 22) labels.push('Royal Line Up');
  return labels.join(' · ') || 'Child inventory';
}
